<template>
  <div class="columns is-multiline is-centered">
    <div class="column is-12 has-text-centered">
      <roles-list
          :roles="roles"
          :pagination="pagination"
          :getRoles="getRolesList"
          :isLoading="isLoading"
          :role="roleCode"
        />
    </div>
    <modal-component
      :active="isModalOpen"
      @cancel="cancel"
      titleModal="Nuevo rol"
      optionalText="Define el nombre del rol y elige la plantilla de privilegios base sobre la que se configurará."
      @hdlOnClick="save"
      :loading="isLoading"
      :loader="isLoading"
      :scrollBody="false"
      :isOverflow="true"
      textSave="Crear rol"
    >
      <div class="columns is-multiline">
        <div class="column is-12">
          <div class="field">
            <label class="label" for="rolname">Nombre del rol</label>
            <div class="control">
              <input
                id="rolname"
                class="input"
                type="text"
                placeholder="Nombre del rol"
                name="rolname"
                v-model="roleName"
                v-validate="'required'"
                :class="{'is-danger': vverrors.has('rolname')}"
                data-vv-as="Nombre"
              />
            </div>
            <p class="help is-danger">{{ vverrors.first('rolname') }}</p>
          </div>
          <div class="field">
            <label class="label" for="selectedRole">Plantilla de privilegios</label>
            <div class="select is-fullwidth" :class="{'is-danger': vverrors.has('selectedRole')}">
              <select id="selectedRole" v-model="selectedRole" name="selectedRole" v-validate="'required'">
                <option :value="null" disabled>Seleccione una opción</option>
                <option value="admin">Administrador</option>
                <option value="manager">Manager</option>
                <option value="viewer">Revisor</option>
                <option value="analyst">Analista</option>
              </select>
            </div>
            <p class="help is-danger">{{ vverrors.first('selectedRole') }}</p>
          </div>
        </div>
      </div>
    </modal-component>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import mixins from '@/mixins/formats'

export default {
  name: 'Roles',
  mixins: [mixins],
  components: {
    ModalComponent: () => import('@/components/ui/ModalComponent'),
    RolesList: () => import('@/components/Roles/RolesList.vue')
  },
  data () {
    return {
      isLoading: false,
      pagination: {
        pageNumber: 1
      },
      roles: [],
      roleName: '',
      isModalOpen: false,
      selectedRole: null,
      enableAddRole: false
    }
  },
  mounted () {
    this.getRolesList()
    if (this.roleCode?.code === 'custom') {
      this.hasCustomRoleAccess()
    }
  },
  methods: {
    ...mapActions(['getRoles', 'saveCustomRole', 'getServicePermission']),
    emitTitleAction () {
      this.$emit('update-title-action', {
        label: 'Nuevo rol',
        visible: this.hasRoleAddAccess,
        disabled: false,
        handler: this.openCreateModal
      })
    },
    openCreateModal () {
      if (this.hasRoleAddAccess) {
        this.isModalOpen = true
      }
    },
    async getRolesList (page) {
      this.isLoading = true
      try {
        const response = await this.getRoles({ pageNumber: page, perPage: 10 })
        if (response) {
          const { roles, pagination } = response
          this.roles = roles
          this.pagination = pagination
        }
      } finally {
        this.isLoading = false
      }
    },
    async save () {
      if (await this.$validator.validateAll()) {
        this.isLoading = true
        const responseStatus = await this.saveCustomRole({ roleName: this.roleName, roleBase: this.selectedRole })
        if (responseStatus) {
          await this.getRolesList(0)
        }
        this.roleName = ''
        this.selectedRole = null
        this.isLoading = false
        this.isModalOpen = false
      }
    },
    cancel () {
      this.isModalOpen = false
      this.roleName = ''
      this.selectedRole = null
    },
    async hasCustomRoleAccess () {
      const resp = await this.getServicePermission(['saveUser'])
      const filter = resp.filter(service => service.enabled).map(service => service.code)
      this.enableAddRole = filter.includes('saveUser')
      this.emitTitleAction()
    }
  },
  computed: {
    ...mapState({
      systemConfiguration: state => state.configuration,
      roleCode: state => state.financialCompany?.role
    }),
    hasRoleAddAccess () {
      const adminRoles = ['admin', 'manager', 'compliance']
      return adminRoles.includes(this.roleCode?.code) || this.enableAddRole
    }
  },
  watch: {
    roleCode (newValue) {
      if (newValue?.code === 'custom') {
        this.hasCustomRoleAccess()
      } else {
        this.enableAddRole = false
        this.emitTitleAction()
      }
    },
    hasRoleAddAccess () {
      this.emitTitleAction()
    }
  },
  created () {
    this.emitTitleAction()
  }
}
</script>
